import(/* webpackMode: "eager" */ "/buggy-mccodeface-academy/components/site-header.tsx")